
import Stickyfill from 'stickyfilljs';

  // @ie11 sticky fix
window.bindStickyfill = () => {
    Stickyfill.add($('.sticky-top'));
    var scrollers = Stickyfill.add($('.scroller__col.scroller__col--left'));
    $.each(scrollers, function (index, scroller) {
        // This fixes multiple scrolls with the header
        if (scroller._active) {
            scroller._node.style.top = "0";
            scroller._offsetToParent.top = "0";
        }
    });
}
document.addEventListener('DOMContentLoaded', function () {
    window.bindStickyfill();
});